/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthEmailControllerAuthorizeByEmailMutationRequest,
  TelegramAuthEmailControllerAuthorizeByEmailMutationResponse,
  TelegramAuthEmailControllerAuthorizeByEmail401,
  TelegramAuthEmailControllerAuthorizeByEmail403,
} from '../types/TelegramAuthEmailControllerAuthorizeByEmail.ts';

function getTelegramAuthEmailAuthorizeByEmailUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/email/login` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/email/login}
 */
export async function telegramAuthEmailAuthorizeByEmail(
  data: TelegramAuthEmailControllerAuthorizeByEmailMutationRequest,
  config: Partial<RequestConfig<TelegramAuthEmailControllerAuthorizeByEmailMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthEmailControllerAuthorizeByEmailMutationResponse,
    ResponseErrorConfig<
      TelegramAuthEmailControllerAuthorizeByEmail401 | TelegramAuthEmailControllerAuthorizeByEmail403
    >,
    TelegramAuthEmailControllerAuthorizeByEmailMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthEmailAuthorizeByEmailUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
